import React from 'react';
import styled from 'styled-components';

const TopWarning = styled.div`
  background: var(--gray3);
  padding: 6px 10px;
  text-align: center;
`;

export function BuyPanelTopWarning({ isPostOnly }: { isPostOnly: boolean }) {
  if (!isPostOnly) {
    return null;
  }
  return <TopWarning>This market is in Post-Only mode .</TopWarning>;
}
